// extracted by mini-css-extract-plugin
module.exports = {"box":"App_box__3ueLk","phonebook":"App_phonebook__2Z20o","contacts":"App_contacts__2z-BD"};